import CoachGateway from "../../gateways/coach_gateway";

export default {
  name: 'coachGateway',
  fn: CoachGateway
};